import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=2dab3bfa&scoped=true&"
import script from "./specs.vue?vue&type=script&lang=js&"
export * from "./specs.vue?vue&type=script&lang=js&"
import style0 from "./specs.vue?vue&type=style&index=0&id=2dab3bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab3bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dab3bfa')) {
      api.createRecord('2dab3bfa', component.options)
    } else {
      api.reload('2dab3bfa', component.options)
    }
    module.hot.accept("./specs.vue?vue&type=template&id=2dab3bfa&scoped=true&", function () {
      api.rerender('2dab3bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/product/specs.vue"
export default component.exports